// import { Box, useTheme } from '@mui/material';
// import React from 'react'
// import { Bar, Pie, Line } from 'react-chartjs-2'

// function EnergyReportingChart({ data, labels }) {
//     const { typography } = useTheme()

//     return (

//         <Line style={{ overflow: 'scroll' }}
//             options={{
//                 responsive: true,
//                 maintainAspectRatio: true,
//                 animation: false,
//                 plugins: {
//                     legend: {
//                         position: 'top',
//                         display: true
//                     },
//                     title: {
//                         display: false,
//                         position: 'left',
//                         text: 'Temperature in Celsius Degree',
//                     },
//                     tooltip: {
//                         mode: 'index',
//                         intersect: false,
//                     },
//                     filler: {
//                         propagate: true
//                     }

//                 },
//                 spacing: 1,
//                 aspectRatio: 3,
//                 scales: {
//                     y: {
//                         ticks: {
//                             // color: 'yellow',
//                             font: {
//                                 size: 10,
//                             }
//                         }
//                     },
//                     x: {
//                         ticks: {
//                             // color: 'inherit',
//                             font: {
//                                 size: 10
//                             }
//                         }
//                     }
//                 }
//             }}
//             data={{
//                 labels: labels,
//                 datasets: data

//             }} />


//     )
// }

// export default EnergyReportingChart


// 2.

import React from "react";
import { Box, useTheme } from "@mui/material";
import { Line } from "react-chartjs-2";

function EnergyReportingChart({ data, labels }) {
  const { typography } = useTheme();

  // Increase line width for all datasets
  const updatedDatasets = data.map((dataset) => ({
    ...dataset,
    borderWidth: 2,        // <-- Increase line thickness
    pointRadius: 2,
    pointHoverRadius: 5,
    tension: 0.4,          // Smooth curve
  }));

  return (
    <Box
      sx={{
        width: "100%",
        height: 400,
      }}
    >
      <Line
        options={{
          responsive: true,
          maintainAspectRatio: false,
          animation: false,
          interaction: {
            mode: "index",
            intersect: false,
          },
          plugins: {
            legend: {
              position: "top",
              display: true,
              labels: {
                font: {
                  size: 12,
                },
              },
            },
            title: {
              display: false,
            },
            tooltip: {
              mode: "index",
              intersect: false,
            },
            filler: {
              propagate: true,
            },
          },
          scales: {
            y: {
              ticks: {
                font: {
                  size: 10,
                },
              },
              grid: {
                display: true,
              },
            },
            x: {
              ticks: {
                font: {
                  size: 10,
                },
              },
              grid: {
                display: true,
              },
            },
          },
        }}
        data={{
          labels: labels,
          datasets: updatedDatasets,
        }}
      />
    </Box>
  );
}

export default EnergyReportingChart;